import { useCallback } from 'react';

import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';
import { useMediaQuery, useTheme } from '@/shared/ui';

import CookieBannerFull from '@/app/components/CookieBanner/CookieBannerFull/index';
import CookieBannerMobile from '@/app/components/CookieBanner/CookieBannerMobile/index';
import { clearSelection } from '@/features/symbol-selector';
import { clock } from '@/services/clock';
import { logout } from '@/store/authActions';
import { useAppDispatch } from '@/store/hooks';

const CookieBanner = () => {
  const [cookies, setCookie] = useCookies(['cookies-accepted']);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleDecline = useCallback(() => {
    dispatch(clearSelection());
    dispatch(logout());
    navigate('/login');
  }, [dispatch, navigate]);

  const handleAccept = useCallback(() => {
    const expires = clock.date();
    expires.setFullYear(expires.getFullYear() + 2);

    setCookie('cookies-accepted', true, {
      expires,
      path: '/',
      sameSite: 'lax',
      secure: window.location.protocol === 'https:'
    });
  }, [setCookie]);

  const theme = useTheme();
  const showMobileBanner = useMediaQuery(theme.breakpoints.down('md'));

  if (cookies['cookies-accepted']) return null;

  return showMobileBanner ? (
    <CookieBannerMobile
      handleAccept={handleAccept}
      handleDecline={handleDecline}
    />
  ) : (
    <CookieBannerFull
      handleAccept={handleAccept}
      handleDecline={handleDecline}
    />
  );
};

export default CookieBanner;
